"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireWildcard(require("react"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var ErrorBoundary = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(ErrorBoundary, _React$Component);

  var _super = _createSuper(ErrorBoundary);

  function ErrorBoundary(props) {
    var _this;

    (0, _classCallCheck2.default)(this, ErrorBoundary);
    _this = _super.call(this, props);
    _this.state = {
      // checks if an error has occured in its children.
      error: ""
    };
    return _this;
  }

  (0, _createClass2.default)(ErrorBoundary, [{
    key: "componentDidCatch",
    value: function componentDidCatch(err, info) {
      // eslint-disable-next-line no-console
      console.error(err);
      this.setState({
        error: err.message
      });
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.error) {
        return /*#__PURE__*/_react.default.createElement("div", null, "Error occurred. ", this.state.error);
      } else {
        return this.props.children;
      }
    }
  }]);
  return ErrorBoundary;
}(_react.default.Component);

var FieldWrapper = function FieldWrapper(props) {
  var _props$model$value;

  var _props$model = props.model,
      _onChange = _props$model.onChange,
      component = _props$model.component,
      other = (0, _objectWithoutProperties2.default)(_props$model, ["onChange", "component"]);

  var _useState = (0, _react.useState)((_props$model$value = props.model.value) !== null && _props$model$value !== void 0 ? _props$model$value : ""),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  var Component = component;
  return /*#__PURE__*/_react.default.createElement(ErrorBoundary, null, /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({}, other, {
    disabled: props.disabled,
    attachComponentToForm: function attachComponentToForm(component) {
      props.onAttach(component);
    },
    onBlur: function onBlur() {
      props.onBlur();
    },
    value: value,
    onChange: function onChange() {
      var _params$, _params$$preventDefau, _params$2, _params$2$stopPropaga, _result$value;

      for (var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++) {
        params[_key] = arguments[_key];
      }

      (_params$ = params[0]) === null || _params$ === void 0 ? void 0 : (_params$$preventDefau = _params$.preventDefault) === null || _params$$preventDefau === void 0 ? void 0 : _params$$preventDefau.call(_params$);
      (_params$2 = params[0]) === null || _params$2 === void 0 ? void 0 : (_params$2$stopPropaga = _params$2.stopPropagation) === null || _params$2$stopPropaga === void 0 ? void 0 : _params$2$stopPropaga.call(_params$2);
      var result = _onChange === null || _onChange === void 0 ? void 0 : _onChange(params); // Workaround to fix validations by adding display properties onto result.

      if (result.value && (0, _typeof2.default)(result.value) === "object" && !Array.isArray(result.value)) {
        var _result$display;

        result.value = _objectSpread(_objectSpread({}, result.value), (_result$display = result.display) !== null && _result$display !== void 0 ? _result$display : {});
      }

      setValue((_result$value = result.value) !== null && _result$value !== void 0 ? _result$value : "");
      props.onChange(props.field, result.value);
    }
  })));
};

var _default = FieldWrapper;
exports.default = _default;